module.exports = __webpack_public_path__ + "static/media/blog3_sm.19cb74b1.webp";